class RoLoadMore extends HTMLElement {
    constructor() {
        super();
        this.nextUrl = this.dataset.next;
        this.currentPage = this.dataset.current;
        this.totalPages = this.dataset.pages;
        this.url = this.dataset.url;
        this.wrapperClass = this.dataset.wrapperClass;
        this.subWrapperClass = this.dataset.subWrapperClass;
        this.gridItemClass = this.dataset.gridItemClass;
        this.button = this.querySelector(".js-load-more");
        this.productItem = null;
        this.totalItems = this.dataset.itemNumber;
        this.showItemPerPage = this.dataset.showItemPerPage ?? 'true';
        this.itemPerPage = parseInt(this.dataset.itemPerPage);
        this.pageStored = parseInt(localStorage.getItem('currentPage'));
    }

    connectedCallback() {
        this.listener();
        this.itemPerPage = 0;
        document.querySelector(`.${this.wrapperClass}`).querySelectorAll(`.${this.subWrapperClass}`).forEach((element) => {
            for(let i=0;i<element.children.length;i++){
                if(!element.children[i].classList.contains('grid__item-image')){
                    this.itemPerPage++;
                }
            }
        })
        //remove the last product item and save it in the load more 
        
        if (this.dataset.image == "true" && this.currentPage != this.totalPages) {
            this.productItem = this.previousElementSibling.removeChild(this.previousElementSibling.lastChild);
            this.itemPerPage--;
        }
        
        this.dataset.itemPerPage = this.itemPerPage;
        if (this.showItemPerPage === 'true') {
            this.querySelector('.js-item-per-page').innerText = this.itemPerPage
        }
    }

    listener() {
        this.button.addEventListener('click', () => { this.loadProduct() })
    }

    loadProduct() {
        if (parseInt(this.currentPage) >= parseInt(this.totalPages)) {
            this.querySelector('[load-more-text]').innerText = 'Products Finished';
        } else {
            this.querySelector('[load-more-text]').classList.add('hide');
            document.querySelector(`.${this.wrapperClass}`).classList.add("loading");

            fetch(this.nextUrl)
            .then(function (response) {
                return response.text();
            })
            .then(function (html) {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                // Insert new content
                let newLoadMore = doc.querySelector('ro-load-more');
                let newGrid = doc.querySelector(`.${this.wrapperClass} .${this.subWrapperClass}`);
                //Add last element of the previus grid as first element of the new grid
                if (this.dataset.image == "true") {
                    this.productItem.style="--animation-order: 1"
                    newGrid.insertBefore(this.productItem, newGrid.firstChild);
                }
                let newGridItems = newGrid.querySelectorAll(`.${this.gridItemClass}`);
                const currentGrid = document.querySelector(`.${this.wrapperClass} .${this.subWrapperClass}`);
                
                // Append grid items to the current grid
                newGridItems.forEach((newItem) => {
                    currentGrid.appendChild(newItem);
                });
                
                // Find the first newly added item for focus management
                let firstNewItem = null;
                if (this.dataset.image == "true" && this.productItem) {
                    // If productItem was inserted, it's the first one
                    firstNewItem = this.productItem;
                } else if (newGridItems.length > 0) {
                    // Otherwise, the first new grid item
                    firstNewItem = newGridItems[0];
                }
                
                //Apply the css classes to the new load more
                if (parseInt(this.currentPage) + 1 >= parseInt(this.totalPages)) {
                    newLoadMore.querySelector('.js-load-more').classList.add("tw-hidden");
                    newLoadMore.querySelector('.js-load-more').setAttribute('disabled', true);
                }
                //Append the new laod more button to the grid in oreder to refresh the custom element
                document.querySelector(`.${this.wrapperClass}`).appendChild(newLoadMore);

                // Remove current load more
                document.querySelector(`.${this.wrapperClass}`).removeChild(this);
                
                publish(PUB_SUB_EVENTS.loadMoreFinished);
                
                // Move focus to the first newly loaded item for keyboard navigation
                if (firstNewItem) {
                    // Try to find a focusable element within the card (link, button, or the card itself if it has tabindex)
                    const focusableElement = firstNewItem.querySelector('a[href], button, [tabindex="0"]') || 
                                           (firstNewItem.hasAttribute('tabindex') ? firstNewItem : null);
                    
                    if (focusableElement) {
                        // Use setTimeout to ensure DOM is fully updated and any animations have started
                        setTimeout(() => {
                            focusableElement.focus();
                            // Scroll into view with smooth behavior
                            focusableElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                        }, 100);
                    }
                }
            }
            .bind(this))// Ensure 'this' refers to the custom element
            .catch(function (err) {
                console.warn('Something went wrong.', err);
            })
            .finally(() => {
                    document.querySelector(`.${this.wrapperClass}`).classList.remove("loading");
            });
        }
    }
}

customElements.define('ro-load-more', RoLoadMore);